export const stats = [
  { value: '+540', label: "Unità e Fichè Pronte all'Uso" },
  { value: '+1.500', label: 'Docenti Soddisfatti' },
  { value: '3.800+', label: 'Ore Risparmiate' },
  { value: '98%', label: 'Lo Raccomandano' },
]

export const differenceStats = [
  { value: '+540', label: 'Unità e Attività (1ª Primaria a 3ª Media)' },
  { value: '8', label: 'Volumi Digitali Completi' },
  { value: '100%', label: 'Download Immediato' },
]

export const beforeItems = [
  'Ore passate a pianificare ogni singola lezione da zero cercando su 10 siti diversi',
  'Esperimenti che falliscono perché non hai i materiali o le istruzioni chiare',
  'Nessuna connessione chiara tra la teoria e il mondo reale',
  'Difficoltà nel creare verifiche adatte a diversi livelli (BES/DSA)',
  'Studenti demotivati che pensano che "la scienza sia noiosa"',
]

export const afterItems = [
  '5 minuti di revisione e sei pronto per entrare in classe con sicurezza',
  'Laboratori pratici e coinvolgenti con materiali facili da trovare',
  'Infografiche e mappe concettuali integrate in ogni unità',
  'Quiz, verifiche, soluzioni e rubriche già pronti al 100%',
  'Studenti che osservano, sperimentano e capiscono davvero',
]

export const recognizeItems = [
  {
    emoji: '😰',
    text: "Ansia da spiegazione: arrivare in classe senza sapere come spiegare un concetto complesso (come la fotosintesi o l'elettricità) in modo semplice",
  },
  {
    emoji: '⏱️',
    text: "Domeniche rubate: passare l'intera domenica a preparare materiali didattici che dovrebbero richiedere minuti",
  },
  {
    emoji: '🤷',
    text: 'Caos creativo: faticare a trovare schede didattiche che siano davvero di alta qualità, visive e moderne',
  },
  {
    emoji: '📋',
    text: 'Valutazione infinita: nessuna rubrica di valutazione chiara o test allineato con il programma ministeriale',
  },
  {
    emoji: '😴',
    text: 'Studenti persi: alunni che restano indietro perché il materiale non è adatto al loro livello o non è inclusivo (BES/DSA)',
  },
]

export const packItems = [
  {
    emoji: '📚',
    title: '8 Volumi basati sull\u2019Anno Scolastico (1ª Primaria – 3ª Media)',
    text: 'Un curriculum scientifico completo: dalla scoperta dei sensi alla tettonica delle placche',
  },
  {
    emoji: '🧪',
    title: 'Kit Laboratorio ed Esperimenti',
    text: 'Schede tecniche per esperimenti pratici da fare in classe, con materiali poveri e spiegazioni passo-passo',
  },
  {
    emoji: '✏️',
    title: 'Script delle Lezioni «Pronti al Volo»',
    text: 'Suggerimenti didattici che ti dicono esattamente cosa dire e come condurre la lezione',
  },
  {
    emoji: '📐',
    title: 'Scienze Visuale: Infografiche e Mappe',
    text: 'Grafiche ad alta risoluzione (8K) che rendono comprensibili i processi invisibili: atomi, cellule, forze',
  },
  {
    emoji: '📊',
    title: 'Verifiche, Soluzioni e BES/DSA',
    text: 'Strumenti di valutazione completi e versioni facilitate per una didattica davvero inclusiva',
  },
  {
    emoji: '🔑',
    title: 'Answer Keys (Chiavi di Correzione)',
    text: 'Soluzioni complete di ogni esercizio per correzioni istantanee e senza stress',
  },
]

export const bonuses = [
  {
    title: 'Planner Annuale Scienze™',
    was: '€19',
    text: "Organizza tutto l'anno in 5 minuti",
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/ce0624e7-00ee-4ef3-8441-6dda62a0c469.jpg',
  },
  {
    title: 'Mappe Concettuali & Glossari™',
    was: '€27',
    text: 'Per una memorizzazione rapida e visiva',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/7c81c5e4-1b08-4d18-b674-1ad9725511c7.jpg',
  },
  {
    title: 'Kit «L\u2019Angolo dello Scienziato»™',
    was: '€36',
    text: "Poster e materiali per allestire l'aula",
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/7cee1188-724a-43b3-85a0-58edcaa6ed5d.jpg',
  },
  {
    title: 'Sistema di Valutazione Rapida™',
    was: '€47',
    text: 'Rubriche e griglie pronte per ogni unità',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/90d98130-daaa-4aa3-8b5d-b29c7383880a.jpg',
  },
  {
    title: 'Quick Check & Certificati™',
    was: '€19',
    text: 'Per premiare i progressi dei tuoi studenti',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/f2e94437-dfbd-4c58-a1e8-ab6e85ce170c.jpg',
  },
]

export const offerRows = [
  { label: 'SCIENZE PRONTA™ Pack (8 Volumi Digitali)', value: '€77' },
  { label: '5 Bonus Strategici Esclusivi', value: '€148' },
]

export const testimonials = [
  {
    quote:
      'Ho finalmente recuperato le mie serate. I laboratori sono semplici da realizzare e i bambini li adorano.',
    name: 'Chiara M.',
    location: 'Milano 🇮🇹',
  },
  {
    quote:
      "Le mappe visuali sono una manna dal cielo per i miei alunni DSA. Materiale professionale e pronto all'uso.",
    name: 'Luca B.',
    location: 'Roma 🇮🇹',
  },
  {
    quote:
      "Dalla prima elementare alle medie, è l'unico investimento che serve a un insegnante di scienze.",
    name: 'Elena V.',
    location: 'Torino 🇮🇹',
  },
]

export const faqs = [
  {
    q: 'Come ricevo il materiale?',
    a: "Immediatamente via email in formato PDF dopo l'acquisto.",
  },
  {
    q: 'Funziona per le medie?',
    a: 'Sì, il pacchetto include volumi specifici per la scuola secondaria di primo grado.',
  },
  {
    q: 'È adatto per alunni BES/DSA?',
    a: 'Assolutamente, ogni unità include schemi semplificati e font leggibili.',
  },
  {
    q: 'Ci sono costi mensili?',
    a: 'No. Paghi una volta e ricevi aggiornamenti a vita.',
  },
]
